import { useInfiniteQuery, type UseInfiniteQueryOptions } from '@lumapps/base-api/react-query';

import { marketplaceConnectorsQueryKeys } from '../api';
import { type FetchProviderListParams, getProviderList } from '../api/providersApi';
import type { ProviderListResponse } from '../types';

// The default is very high because the pagination is not in place in the back-end
const DEFAULT_MAX_RESULTS = '50';

/**
 * Hook to retreive the list of providers
 *
 * @param {FetchProviderListParams | undefined} params
 */
export const useGetProviderList = (params: FetchProviderListParams = {}, options: UseInfiniteQueryOptions = {}) => {
    const paramsWithDefaultMaxResults = {
        ...params,
        maxResults: params.maxResults || DEFAULT_MAX_RESULTS,
    };

    return useInfiniteQuery({
        ...options,
        getNextPageParam: (lastPage: ProviderListResponse) => (lastPage.more ? lastPage.cursor : undefined),
        queryKey: marketplaceConnectorsQueryKeys.providers(paramsWithDefaultMaxResults),
        queryFn: async ({ pageParam: cursor }) =>
            getProviderList({ ...paramsWithDefaultMaxResults, cursor }, undefined),
    });
};

export type UseQueryProviderSearchOptions = UseInfiniteQueryOptions;

/**
 * Hook in order to retrieve Providers, filter and load more of them.
 * @returns UseProviders
 */
export const useGetProviderListV2 = (params: FetchProviderListParams, options: UseQueryProviderSearchOptions) => {
    const listProviderQuery = useInfiniteQuery({
        ...options,
        queryKey: marketplaceConnectorsQueryKeys.providers(params),
        queryFn: async ({ pageParam }) => getProviderList({ ...params, cursor: pageParam }, undefined),
        getNextPageParam: (lastPage) => (lastPage?.more ? lastPage?.cursor : undefined),
    });

    return listProviderQuery;
};
